import { inject, InjectionToken } from '@angular/core';
import { RemoteConfigValueType } from '../enums';
import { RemoteConfigService } from '../services';

export interface RemoteConfigProvider {
  fetchAndActivate(): Promise<boolean>;
  getValue<T>(key: string, type: RemoteConfigValueType, defaultValue: T): Promise<T>;
}

export const REMOTE_CONFIG_TOKEN: InjectionToken<RemoteConfigProvider> = new InjectionToken<RemoteConfigProvider>(
  'REMOTE_CONFIG_TOKEN',
  {
    factory: (): RemoteConfigProvider => {
      const service: RemoteConfigService = inject(RemoteConfigService);

      return {
        fetchAndActivate(): Promise<boolean> {
          return service.fetchAndActivate();
        },
        getValue<T>(key: string, type: RemoteConfigValueType, defaultValue: T): Promise<T> {
          return service.getValue<T>(key, type, defaultValue);
        }
      };
    }
  }
);
